(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  $(document).ready(function () {
    let navLinkwithDropdown = $('.rtnu-nav__link--has-dropdown'),
      navDropdown = $('.rtnu-nav__dropdown'),
      menuID,
      mobileNavTrigger = $('#mobileNavTrigger'),
      mobileNav = $('.rtnu-header__mobile-nav'),
      mobileNavLinks = $('.rtnu-header__mobile-nav > ul'),
      mobileNavHasMenu = $('.rtnu-header__mobile-nav--has-nav'),
      mobileNavExpanded = $('.rtnu-header__mobile-nav-expanded'),
      mobileNavBack = $('.rtnu-header__mobile-nav-back');

    navLinkwithDropdown.hover(
      function () {
        $(this).find(navDropdown).stop().slideDown(300);
        $(this).addClass('hovering');
        $('body').addClass('dropdown-open');
      },
      function () {
        $(this).find(navDropdown).stop().slideUp(300);
        $(this).removeClass('hovering');
        $('body').removeClass('dropdown-open');
      }
    );

    mobileNavTrigger.click(function () {
      $(this).toggleClass('is-active');
      // mobileNav.slideToggle('fast');
      $('.rtnu-header__mobile-nav-container').toggleClass('active');
    });

    // mobileNavHasMenu.click(function() {
    //   menuID = $(this).data("nav-id");
    //   mobileNavLinks.hide();
    //   mobileNavHasMenu.hide();
    //   mobileNavExpanded.show();
    //   mobileNavExpanded.find("[data-nav-id='" + menuID + "']").show();
    // });

    // mobileNavBack.click(function() {
    //   mobileNavExpanded.hide();
    //   mobileNavLinks.show();
    //   mobileNavHasMenu.show();
    // });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.splide__slide')) {
            this.classList.add('product-recommendations--loaded');
          }

          let recommendationsSlider = new Splide( '.rtnu-product-recommendations__slider', {
            destroy: true,
            breakpoints: {
              768: {
                destroy: false,
                perMove: 1,
                gap: 16,
                fixedWidth: '319px',
                pagination: true,
                arrows: false,
                padding: '20px',
              },
            },
          });

          recommendationsSlider.mount();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
